
import React from 'react';
import { Form } from '@/components/ui/form';
import { SignupFormField, SignupFormConfig } from '@/schemas/signupFormSchema';
import DynamicSignupField from './DynamicSignupField';
import CaptchaField from './CaptchaField';
import SubmitButton from '@/components/auth/SubmitButton';
import AuthFooter from '@/components/auth/AuthFooter';
import { useDynamicForm } from '@/hooks/useDynamicForm';

interface DynamicFormProps {
  onSubmit: (data: Record<string, any>) => void;
  isLoading: boolean;
  formConfig: SignupFormConfig;
  isCurrentPlan?: boolean;
}

const DynamicForm = ({ 
  onSubmit, 
  isLoading, 
  formConfig,
  isCurrentPlan = false
}: DynamicFormProps) => {
  const { 
    form, 
    handleSubmit, 
    visibleFields, 
    handleCaptchaGenerate 
  } = useDynamicForm({
    onSubmit,
    formConfig
  });
  
  return (
    <div>
      <Form {...form}>
        <form onSubmit={form.handleSubmit(handleSubmit)} className="space-y-5">
          {visibleFields.map((field) => (
            <DynamicSignupField 
              key={field.id}
              field={field} 
              form={form} 
            />
          ))}
          
          <CaptchaField 
            form={form} 
            onGenerate={handleCaptchaGenerate} 
          />
          
          <SubmitButton 
            isLoading={isLoading}
            text={isCurrentPlan ? "Current Plan" : "Create Account"}
            loadingText={isCurrentPlan ? "Loading..." : "Creating Account..."}
            className={isCurrentPlan ? "bg-sky-500 hover:bg-sky-600" : ""}
            disabled={isCurrentPlan}
          />
        </form>
      </Form>
      
      {!isCurrentPlan && (
        <AuthFooter 
          text="Already have an account?"
          linkText="Log in"
          linkTo="/login"
        />
      )}
    </div>
  );
};

export default DynamicForm;
